
import { Event } from './types';
import mockEventsData, { futureEvents } from './mockEvents';
import { generateFutureEvents } from './eventGenerator';
import { eventTypeLabels, audienceLabels } from './eventLabels';
import { 
  filterEvents, 
  groupEventsByDate, 
  getFeaturedEvents, 
  getUpcomingEvents, 
  getEventsByType 
} from './eventFilters';
import { 
  formatEventDate, 
  formatEventTime, 
  getEventDateRangeString 
} from './eventHelpers';

// Generate the future events
let year2025Events: Event[] = [];

// Function to load all events
const loadAllEvents = async (): Promise<Event[]> => {
  if (year2025Events.length === 0) {
    // Only generate if not already generated
    year2025Events = await generateFutureEvents();
  }
  return [...mockEventsData, ...year2025Events];
};

// Initial events array, will be populated asynchronously
let events: Event[] = [...mockEventsData, ...futureEvents];

// Load events asynchronously when this module is imported
loadAllEvents().then(loadedEvents => {
  events = loadedEvents;
  console.log(`Loaded ${events.length} events with professions integration`);
}).catch(error => {
  console.error('Error loading events with professions:', error);
});

// Export events
export const allEvents = events;

// Re-export everything to maintain the same API
export {
  eventTypeLabels,
  audienceLabels,
  filterEvents,
  groupEventsByDate,
  getFeaturedEvents,
  getUpcomingEvents,
  getEventsByType,
  formatEventDate,
  formatEventTime,
  getEventDateRangeString
};
